import React, { useState, useEffect } from "react";
import { CircularProgress, Typography, Button, Box } from "@material-ui/core";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { makeStyles } from "@material-ui/styles";
import styles from "./login.less";
import FormItem from "../../../components/FormItem/item.js";

import { handleLoginResponse } from "../actions";
import logo from "../../../assets/logo.png";
import { useSnackbar } from "notistack";
import ExirioStyles from "../../../utils/exirioStyles";
import { LoginUserWithTwoFactorAction } from "../../../services";
import LoginHandler from "./LoginHandler";
import { useTwoFactorTimer } from "../../../hooks/useTwoFactorTimer";
import { twoFactorTimerUtils } from "../../../utils/twoFactorTimer";

const TwoFactorAuthentication = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { isMobile, loginPayloadTwoFactor } = useSelector((state) => ({
    isMobile: state.theme.isMobile,
    loginPayloadTwoFactor: state.login.loginPayloadTwoFactor,
  }));

  const history = useHistory();
  const { remainingTime, formattedTime, clearTimer } = useTwoFactorTimer();

  const [validate, setValidate] = useState(false);

  const useStyles = makeStyles((theme) => ({
    navLogo: {
      fontSize: "28px",
      fontFamily: "Source Sans Pro",
      color: "white",
    },
    flexCenter: {
      display: "flex",
      alignItems: "center",
    },
    //////////////////new styles
    title: {
      color: ExirioStyles.secondaryWhiteText,
      fontSize: "23px",
      color: "lightgray",
      width: "100%",
      padding: "11px 8px",
      borderBottom: "1px solid",
      borderBlockColor: ExirioStyles.background,
      // borderColor:ExirioStyles.background
    },
    smtitle: {
      // color: ExirioStyles.secondaryWhiteText,
      fontSize: "16px",
      // color: 'lightgray'
    },
    regForm: {
      display: "flex",
      justifyContent: "center",
      width: "60%",
      paddingTop: "20px",
      // paddingBottom: '10px'
    },
    mobRegForm: {
      display: "flex",
      justifyContent: "center",
      width: "85%",
      paddingTop: "20px",
      // paddingBottom: '10px'
    },
    btnWrap: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      paddingTop: "20px",
      paddingBottom: "20px",
    },
    btn: {
      borderRadius: 40,
      padding: "8px 28px 8px 28px",
      backgroundColor: "#006DEA",
    },
    loader: {
      position: "absolute",
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: "rgba(255,255,255,0.3)",
    },
    headWrapper: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
    },
    circleIcon: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      textAlign: "center",
      // lineHeight: "20px",
      cursor: "pointer",
    },
    timerDisplay: {
      textAlign: "center",
      padding: "10px 0",
      borderRadius: "8px",
    },
    timerText: {
      fontSize: "14px",
      color: remainingTime && remainingTime < 60000 ? "#f44336" : "lightgray",
      fontWeight: remainingTime && remainingTime < 60000 ? "bold" : "normal",
    },
  }));

  const classes = useStyles();

  const [values, setValues] = useState({
    otp: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleAddToHomescreenClick = () => {
    alert(`
    1. Open Share menu
    2. Tap on "Add to Home Screen" button`);
  };

  useEffect(() => {
    // Check if 2FA session exists and is valid
    if (!loginPayloadTwoFactor) {
      console.log("No two-factor payload, redirecting to login");
      history?.push("/login");
      return;
    }

    // Check if session has expired
    if (twoFactorTimerUtils.isExpired()) {
      console.log("Two-factor session expired, will be handled by hook");
      // The useTwoFactorTimer hook will handle timeout automatically
      return;
    }
  }, [history, loginPayloadTwoFactor]);

  const checkReqiredFields = () => {
    if (!values.otp)
      return {
        error: true,
        success: false,
        message: "Please enter OTP.",
      };
    return { error: false, success: true };
  };

  const onChange = (prop) => (e) => {
    e.preventDefault();
    e.persist();
    setValues(() => ({
      ...values,
      [prop]: e.target.value,
    }));
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    let { success, message } = await checkReqiredFields();
    if (success) {
      const payload = {
        user_id: loginPayloadTwoFactor?.user_id,
        two_factor_user_token: loginPayloadTwoFactor?.two_factor_user_token,
        otp: values.otp,
      };
      setIsSubmitting(true);

      const response = await LoginUserWithTwoFactorAction(payload);
      if (response.success) {
        console.log("Two-factor authentication successful, clearing timer");
        // Clear timer on successful verification
        clearTimer();

        handleLoginResponse(dispatch, response);
        dispatch({ type: "SET_LOGIN_RESPONSE_FOR_TWOFACTOR", payload: null });
        setIsSubmitting(false);
      } else {
        enqueueSnackbar(` ${response?.message}`, {
          variant: "error",
        });
        setIsSubmitting(false);
      }
    } else {
      setValidate(true);
      enqueueSnackbar(` ${message}`, {
        variant: "error",
      });
    }
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      onSubmit();
    }
  };

  return (
    <LoginHandler>
      {isSubmitting && (
        <div className={classes.loader}>
          <CircularProgress />
        </div>
      )}

      <div className={styles.content}>
        <div className={styles.main}>
          <div className={classes.title}>
            <Typography> Two-factor authentication</Typography>
          </div>

          {/* Timer Display */}

          <div className={styles.logo}>
            <div className={classes.flexCenter}>
              <img src={logo} alt="logo" className={styles.wealthLogo} />
              <Typography
                className={classes.navLogo}
                variant="h4"
                color="primary"
              >
                EXIRIO
              </Typography>
            </div>
            {/* <Typography className={styles.logos} variant='h6' >
                    Welcome back! Log in to continue
                </Typography> */}
          </div>
          <div className={classes.headWrapper}>
            <Typography className={styles.logos} variant="h6">
              Two-factor authentication
            </Typography>
            <Typography className={classes.smtitle}>
              Please enter OTP generated on authenticator app
            </Typography>
          </div>
          {remainingTime !== null && (
            <div className={classes.timerDisplay}>
              <Typography variant="caption" className={classes.timerText}>
                Session expires in: {formattedTime}
              </Typography>
              {remainingTime && remainingTime < 60000 && (
                <Typography
                  variant="caption"
                  style={{
                    display: "block",
                    color: "#f44336",
                    fontWeight: "bold",
                  }}
                >
                  ⚠️ Less than 1 minute remaining
                </Typography>
              )}
            </div>
          )}
          <div className={isMobile ? classes.mobRegForm : classes.regForm}>
            <form autoComplete="on">
              <FormItem
                id={"otp"}
                name={"otp"}
                autoComplete={"on"}
                autocompletetype={"username email"}
                value={values.otp}
                label={"OTP"}
                handleChange={onChange("otp")}
                onKeyPress={handleKeypress}
                required={true}
                size={"small"}
                margin={"dense"}
                autoFocus={true}
              />

              <div className={classes.btnWrap}>
                <Button
                  size="medium"
                  className={classes.btn}
                  disabled={isSubmitting}
                  variant="contained"
                  color="primary"
                  type="submit"
                  onClick={onSubmit}
                >
                  Verify
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </LoginHandler>
  );
};
export default TwoFactorAuthentication;
